import {
  Autocomplete,
  Breadcrumbs,
  Button,
  Card,
  Container,
  Grid,
  Input,
  InputLabel,
  TextField,
  Typography,
  Box,
  Tab,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import { useGetCatalogSyncedProductsMutation } from "../redux/reducer/features/Integration/DmsSetupSlice";
import {
  CatalogProductStatus,
  colors,
  Product,
  ProductInitialValues,
  ProductValidationSchema,
} from "../models/features/Product/Product";
import LenghtUnitList from "../compenents/app/LenghtUnitList";
import MassUnitList from "../compenents/app/MassUnitList";
import {
  useCreateProductMutation,
  useDeleteProductImageMutation,
  useDeleteProductMutation,
  useGetCategoriesQuery,
  useGetManufacturersQuery,
  useGetProductByIdMutation,
  useSetImageSequenceMutation,
} from "../redux/reducer/features/Product/productSlice";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ManageProductSection from "../compenents/products/ProductSection";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CatalogSyncedProducts from "../compenents/Edit Product/CatalogSyncedProducts";
import PageLoader from "../compenents/app/PageLoader";
import { FileUploader } from "react-drag-drop-files";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Lightbox from "react-image-lightbox";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
export interface EditProductProps {}

export const EditProduct: React.FunctionComponent<EditProductProps> = () => {
  const { data, isLoading } = useGetCategoriesQuery();
  const [updateProductMutation, updateProductMutationResult] =
    useCreateProductMutation();
  const [isSynced, setIsSynced] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [deleteConfirmImage, setDeleteConfirmImage] = React.useState(false);
  const [imageToDeleteId, setImageToDeleteId] = React.useState("");
  const [updateConfirm, setUpdateConfirm] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [deletionErrorMessage, setDeletionErrorMessage] = React.useState("");
  const [productDetail, setProductDetail] = React.useState<Product>();
  const [updatedProduct, setUpdatedProduct] =
    React.useState<Product>(ProductInitialValues);
  const [syncedProducts, setSyncedProducts] = React.useState<any[]>([]);
  const [detailMutation, detailMutationResult] = useGetProductByIdMutation();
  const [deleteMutation, deleteMutationResult] = useDeleteProductMutation();
  const [getSyncedProductsMutation, getSyncedProductMutationResult] =
    useGetCatalogSyncedProductsMutation();
  const [deleteImageMutation, deleteImageMutationResult] =
    useDeleteProductImageMutation();
  const [setImageSequenceMutation, setImageSequenceMutationResult] =
    useSetImageSequenceMutation();
  const manufacturers = useGetManufacturersQuery();
  let { id } = useParams();
  let navigate = useNavigate();
  const [value, setValue] = React.useState(1);
  const [lightBoxURL, setLightBoxURL] = React.useState("");
  const [isLightBoxOpen, setLightBoxOpen] = React.useState(false);
  const [year, setYear] = React.useState<Dayjs | null>();
  const [savedImages, setSavedImages] = useState<any[]>([]);
  const [images, setImages] = useState<
    { image: File; title: string; description: string }[]
  >([]);
  const [imageMeta, setImageMeta] = useState({
    index: 0,
    title: "",
    description: "",
  });
  const [openImageDialog, setOpenImageDialog] = React.useState<boolean>(false);

  let defaultColors =
    productDetail?.colors?.map((i) => {
      return i.title;
    }) ?? [];
  React.useEffect(() => {
    detailMutation({ data: { id: id } });
  }, []);

  React.useEffect(() => {
    if (detailMutationResult.data) {
      setProductDetail({
        ...detailMutationResult.data.entity,
        status:
          detailMutationResult.data.entity.status === "Active"
            ? CatalogProductStatus.Active
            : CatalogProductStatus.Draft,
      });
      if (detailMutationResult.data.entity?.year) {
        setYear(dayjs(detailMutationResult.data.entity?.year));
      }
      setIsSynced(detailMutationResult.data.entity?.isSynced);
      if (
        detailMutationResult.data.entity.images &&
        detailMutationResult.data.entity.images.length > 0
      ) {
        const sortedImages = [...detailMutationResult.data.entity.images].sort(
          (a: any, b: any) => a.sequence - b.sequence
        );
        setSavedImages(sortedImages);
      }
    }
  }, [detailMutationResult]);
  const categoryDefaultProps = {
    options:
      data && data.entityList
        ? data.entityList.filter((n) => !n.isSubCategory)
        : [],
    getOptionLabel: (option: any) => option.title,
  };

  const manufacturerDefaultProps = {
    options:
      manufacturers.data && manufacturers.data.entityList
        ? manufacturers.data.entityList
        : [],
    getOptionLabel: (option: any) => option.title,
  };

  const handleOnSubmit = (values: Product) => {
    setUpdatedProduct(values);
    setErrorMessage("");
    if (isSynced) {
      setUpdateConfirm(true);
      return;
    } else {
      handleUpdateProduct(values, false);
    }
  };

  const handleUpdateProduct = (
    productData: Product,
    syncWithShopify: boolean
  ) => {
    setErrorMessage("");
    const formData = new FormData();
    formData.append("productJSON", JSON.stringify(productData));
    formData.append("syncWithShopify", syncWithShopify ? "true" : "false");
    images.forEach((imageWithTitle, index) => {
      if (imageWithTitle.image) {
        formData.append(`images[${index}].file`, imageWithTitle.image);
        formData.append(`images[${index}].title`, imageWithTitle.title);
        formData.append(
          `images[${index}].description`,
          imageWithTitle.description
        );
      }
    });

    updateProductMutation({ data: formData }).then((res: any) => {
      if (res.data.status === 200) {
        navigate("/Products");
      } else if (res.data.status === 409) {
        setErrorMessage(
          "This product already exists with same Model and Manufacturer*"
        );
      } else {
        setErrorMessage("Sorry we found an error while creating product.");
      }
    });
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleGetSyncedProducts = () => {
    setOpen(true);
    getSyncedProductsMutation({ productId: id ?? "" }).then((res: any) => {
      if (res && res?.data?.status === 0) {
        setSyncedProducts(res?.data?.entityList);
      }
    });
  };
  const handleClose = () => {
    setLightBoxOpen(false);
    setDeleteConfirm(false);
    setDeleteConfirmImage(false);
    setUpdateConfirm(false);
    setOpenImageDialog(false);
  };
  const handleSaveImageMeta = () => {
    setImages(
      images.map((img, index: number) =>
        index === imageMeta.index
          ? {
              ...img,
              title: imageMeta.title,
              description: imageMeta.description,
            }
          : img
      )
    );
    setOpenImageDialog(false);
  };

  const onDeleteProduct = () => {
    setDeleteConfirm(false);
    deleteMutation({ data: { id: id } }).then((res: any) => {
      if (res.data && res.data.status === 0) {
        navigate("/Products");
      } else {
        setDeletionErrorMessage(
          "Failed to Delete. This product is synced with Product Aggregate."
        );
      }
    });
  };
  const handleDeleteImage = () => {
    deleteImageMutation({ data: { id: imageToDeleteId } });
    setSavedImages(
      savedImages.filter((item: any) => item.id !== imageToDeleteId)
    );
    setDeleteConfirmImage(false);
  };
  const handleDragSavedImagesEnd = (result: any) => {
    if (!result.destination) return;
    const updatedImages = Array.from(savedImages);
    const [reorderedItem] = updatedImages.splice(result.source.index, 1);
    updatedImages.splice(result.destination.index, 0, reorderedItem);
    setSavedImages(updatedImages);
    setImageSequenceMutation({
      imageIds: updatedImages.map((img) => img.id),
    });
  };
  const handleDragLocalImagesEnd = (result: any) => {
    if (!result.destination) return;
    const updatedImages = Array.from(images);
    const [reorderedItem] = updatedImages.splice(result.source.index, 1);
    updatedImages.splice(result.destination.index, 0, reorderedItem);
    setImages(updatedImages);
  };
  return (
    <>
      <Container maxWidth={false}>
        <PageLoader
          isLoading={
            deleteMutationResult.isLoading || detailMutationResult.isLoading
          }
        />
        <Card style={{ padding: "10px", margin: "10px" }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/">
              Dashboard
            </Link>
            <Link color="inherit" to="/Products">
              Products
            </Link>
            <Typography color="text.primary">Edit Product</Typography>
          </Breadcrumbs>
        </Card>
        <Card style={{ padding: "10px", margin: "10px" }}>
          <TabContext value={value.toString()}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Product Detail" value="1" />
                <Tab label="Sections" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              {productDetail ? (
                <Formik
                  initialValues={productDetail ?? ProductInitialValues}
                  enableReinitialize
                  validationSchema={ProductValidationSchema}
                  onSubmit={(values) => {
                    handleOnSubmit(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                  }) => (
                    <>
                      <Form>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginLeft: 1,
                          }}
                        >
                          <Typography color="error">
                            {deletionErrorMessage}
                          </Typography>
                          <Box display="flex">
                            <Button
                              color="error"
                              size="small"
                              variant="contained"
                              disabled={isSynced}
                              onClick={() => {
                                setDeleteConfirm(true);
                              }}
                              sx={{
                                marginRight: "10px",
                              }}
                            >
                              Delete
                            </Button>
                            <Button
                              color="warning"
                              size="small"
                              variant="contained"
                              onClick={handleGetSyncedProducts}
                              sx={{
                                display: isSynced ? "block" : "none",
                                marginRight: "10px",
                              }}
                            >
                              Synced Products
                            </Button>
                          </Box>
                        </Box>

                        <Card style={{ padding: "10px", margin: "10px" }}>
                          <Grid container spacing={3} p={5}>
                            <Grid item xs={6}>
                              <Autocomplete
                                {...manufacturerDefaultProps}
                                id="clear-on-escape"
                                clearOnEscape
                                defaultValue={productDetail.productManufacturer}
                                loading={isLoading}
                                onChange={(e, value) => {
                                  console.log(values);
                                  setFieldValue(
                                    "manufacturerId",
                                    value ? value.id : ""
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Manufacturer"
                                    variant="standard"
                                  />
                                )}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="manufacturerId"
                              />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="modelNumber"
                                name="modelNumber"
                                label="Model Number"
                                fullWidth
                                autoComplete="shipping address-line2"
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.modelNumber}
                                disabled={isSynced}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="modelNumber"
                              />
                            </Grid>
                            {/* <Grid item xs={12} sm={6}>
                              <TextField
                                id="modelName"
                                name="modelName"
                                label="Model Name"
                                fullWidth
                                autoComplete="shipping address-level2"
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.modelName}
                                disabled={isSynced}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="modelName"
                              />
                            </Grid> */}
                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="title"
                                name="title"
                                label="Display Title"
                                fullWidth
                                autoComplete="family-name"
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.title}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="title"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Autocomplete
                                {...categoryDefaultProps}
                                id="clear-on-escape"
                                loading={isLoading}
                                clearOnEscape
                                defaultValue={productDetail.category}
                                onChange={(e, value) => {
                                  setFieldValue(
                                    "productCategoryId",
                                    value ? value.id : ""
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Category"
                                    variant="standard"
                                  />
                                )}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="productCategoryId"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="sku"
                                name="sku"
                                label="SKU"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.sku}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  views={["year"]}
                                  label=" Year"
                                  value={year?.toString() ?? null}
                                  onChange={(newValue) => {
                                    var date = new Date(
                                      newValue?.toString() ?? ""
                                    );
                                    setYear(dayjs(newValue));
                                    setFieldValue(
                                      "year",
                                      date.getFullYear().toString()
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      helperText={null}
                                      fullWidth
                                      variant="standard"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                id="powerType"
                                name="powerType"
                                label="PowerType"
                                fullWidth
                                autoComplete="shipping country"
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.powerType}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <Autocomplete
                                multiple
                                options={colors}
                                defaultValue={[...defaultColors]}
                                id="clear-on-escape"
                                clearOnEscape
                                onChange={(e, value) => {
                                  setFieldValue(
                                    "colors",
                                    value.map((item) => ({
                                      title: item,
                                      shortTitle: item,
                                      productId: values.id,
                                    }))
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Colors"
                                    variant="standard"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                id="upc"
                                name="upc"
                                label="UPC"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.upc}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.depth" shrink>
                                Length
                              </InputLabel>
                              <Input
                                id="dimension.length"
                                name="dimension.length"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.length}
                                endAdornment={
                                  <LenghtUnitList
                                    value={values.dimension?.lengthUnit}
                                    id={"dimension.lengthUnit"}
                                    name={"dimension.lengthUnit"}
                                    onChange={handleChange}
                                  ></LenghtUnitList>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.height" shrink>
                                Height
                              </InputLabel>
                              <Input
                                id="dimension.height"
                                name="dimension.height"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.height}
                                endAdornment={
                                  <LenghtUnitList
                                    value={values.dimension?.heightUnit}
                                    id={"dimension.heightUnit"}
                                    name={"dimension.heightUnit"}
                                    onChange={handleChange}
                                  ></LenghtUnitList>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.width" shrink>
                                width
                              </InputLabel>
                              <Input
                                id="dimension.width"
                                name="dimension.width"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.width}
                                endAdornment={
                                  <LenghtUnitList
                                    value={values.dimension?.widthUnit}
                                    id={"dimension.widthUnit"}
                                    name={"dimension.widthUnit"}
                                    onChange={handleChange}
                                  ></LenghtUnitList>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.weight" shrink>
                                Weight
                              </InputLabel>
                              <Input
                                id="dimension.weight"
                                name="dimension.weight"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.weight}
                                endAdornment={
                                  <MassUnitList
                                    value={values.dimension?.weightUnit}
                                    id={"dimension.weightUnit"}
                                    name={"dimension.weightUnit"}
                                    onChange={handleChange}
                                  ></MassUnitList>
                                }
                              />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                              <TagsInput
                                value={values.tags}
                                onChange={(tags) => {
                                  setFieldValue("tags", tags);
                                }}
                                name="Tags"
                                placeHolder="enter tags"
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <ReactQuill
                                id={"description"}
                                value={values.description}
                                onChange={(e) => {
                                  setFieldValue("description", e);
                                }}
                                modules={{
                                  clipboard: {
                                    matchVisual: false,
                                  },
                                }}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="description"
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <FileUploader
                                handleChange={(e: any) => {
                                  const files = Array.from(e as FileList); // Convert FileList to array of File
                                  const newImages = files.map((file) => ({
                                    image: file,
                                    title: "",
                                    description: "",
                                  }));
                                  setImages([...images, ...newImages]);
                                }}
                                maxSize={20}
                                multiple
                                name="images"
                                types={["JPG", "JPEG", "PNG", "WebP"]}
                              />
                            </Grid>
                            <DragDropContext
                              onDragEnd={handleDragLocalImagesEnd}
                            >
                              <Droppable
                                droppableId="images"
                                direction="horizontal"
                              >
                                {(provided) => (
                                  <Grid
                                    container
                                    item
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    gap={2}
                                    flexWrap="wrap"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    {images.map((file, index) => (
                                      <Draggable
                                        key={index}
                                        draggableId={`image-${index}`}
                                        index={index}
                                      >
                                        {(provided) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                              position: "relative",
                                              display: "inline-block",
                                              border: "1px solid black",
                                              width: "150px",
                                              height: "100px",
                                              borderRadius: "10px",
                                              ...provided.draggableProps.style,
                                            }}
                                          >
                                            <img
                                              style={{
                                                height: "100%",
                                                width: "100%",
                                                borderRadius: "10px",
                                              }}
                                              alt="preview image"
                                              onClick={() => {
                                                setLightBoxOpen(true);
                                                setLightBoxURL(
                                                  URL.createObjectURL(
                                                    file.image
                                                  )
                                                );
                                              }}
                                              src={URL.createObjectURL(
                                                file.image
                                              )}
                                            />
                                            <IconButton
                                              size="small"
                                              style={{
                                                position: "absolute",
                                                top: 1,
                                                right: 30,
                                                backgroundColor: "white",
                                              }}
                                              onClick={() => {
                                                setImageMeta({
                                                  index: index,
                                                  title: file.title,
                                                  description: file.description,
                                                });
                                                setOpenImageDialog(true);
                                              }}
                                            >
                                              <MoreHorizIcon
                                                sx={{
                                                  color: "black",
                                                  fontSize: "13px",
                                                }}
                                              />
                                            </IconButton>
                                            <IconButton
                                              size="small"
                                              style={{
                                                position: "absolute",
                                                top: 1,
                                                right: 1,
                                                backgroundColor: "white",
                                              }}
                                              onClick={() => {
                                                setImages(
                                                  images.filter(
                                                    (img, imgIndex) =>
                                                      imgIndex !== index
                                                  )
                                                );
                                              }}
                                            >
                                              <CloseIcon
                                                color="error"
                                                sx={{
                                                  fontSize: "13px",
                                                }}
                                              />
                                            </IconButton>
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </Grid>
                                )}
                              </Droppable>
                            </DragDropContext>

                            <DragDropContext
                              onDragEnd={handleDragSavedImagesEnd}
                            >
                              <Droppable
                                droppableId="images"
                                direction="horizontal"
                              >
                                {(provided) => (
                                  <Grid
                                    container
                                    item
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    gap={2}
                                    flexWrap="wrap"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    {savedImages.map((img, index) => (
                                      <Draggable
                                        key={index}
                                        draggableId={`image-${index}`}
                                        index={index}
                                      >
                                        {(provided) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                              position: "relative",
                                              display: "inline-block",
                                              border: "1px solid black",
                                              width: "150px",
                                              height: "100px",
                                              borderRadius: "10px",
                                              ...provided.draggableProps.style,
                                            }}
                                          >
                                            <img
                                              style={{
                                                height: "100%",
                                                width: "100%",
                                                borderRadius: "10px",
                                              }}
                                              onClick={() => {
                                                setLightBoxOpen(true);
                                                setLightBoxURL(
                                                  img?.absoluteUrl ?? ""
                                                );
                                              }}
                                              alt="preview image"
                                              src={img.absoluteUrl}
                                            />

                                            <IconButton
                                              size="small"
                                              style={{
                                                position: "absolute",
                                                top: 1,
                                                right: 0,
                                                backgroundColor: "white",
                                              }}
                                              onClick={() => {
                                                setDeleteConfirmImage(true);
                                                setImageToDeleteId(
                                                  img.id ?? ""
                                                );
                                              }}
                                            >
                                              <DeleteForeverIcon color="error" />
                                            </IconButton>
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </Grid>
                                )}
                              </Droppable>
                            </DragDropContext>
                            <Grid
                              display={"flex"}
                              alignItems={"center"}
                              gap={3}
                              item
                              xs={12}
                            >
                              <Button
                                variant="contained"
                                type="submit"
                                onClick={() =>
                                  setFieldValue(
                                    "status",
                                    CatalogProductStatus.Active
                                  )
                                }
                                endIcon={
                                  updateProductMutationResult.isLoading &&
                                  values.status ===
                                    CatalogProductStatus.Active ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : (
                                    <></>
                                  )
                                }
                                disabled={updateProductMutationResult.isLoading}
                              >
                                {values.status === CatalogProductStatus.Draft
                                  ? "Save & Add"
                                  : "Save Changes"}
                              </Button>
                              {values.status === CatalogProductStatus.Draft ? (
                                <Button
                                  variant="contained"
                                  type="submit"
                                  onClick={() =>
                                    setFieldValue(
                                      "status",
                                      CatalogProductStatus.Draft
                                    )
                                  }
                                  endIcon={
                                    updateProductMutationResult.isLoading &&
                                    values.status ===
                                      CatalogProductStatus.Draft ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : (
                                      <></>
                                    )
                                  }
                                  disabled={
                                    updateProductMutationResult.isLoading
                                  }
                                >
                                  Save As Draft
                                </Button>
                              ) : null}
                              <Typography className="error-msg">
                                {errorMessage}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Card>
                      </Form>
                    </>
                  )}
                </Formik>
              ) : (
                ""
              )}
            </TabPanel>
            <TabPanel value="2">
              <ManageProductSection productId={id}></ManageProductSection>
            </TabPanel>
          </TabContext>
        </Card>
        <CatalogSyncedProducts
          products={syncedProducts}
          isLoading={getSyncedProductMutationResult.isLoading}
          handleClose={() => {
            setOpen(false);
          }}
          isOpen={open}
        />
        <Dialog open={deleteConfirm} onClose={handleClose} fullWidth>
          <DialogTitle>Confirm to delete</DialogTitle>
          <DialogContent>Are you sure to delete this product?</DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setDeleteConfirm(false);
              }}
            >
              No
            </Button>
            <Button variant="contained" size="small" onClick={onDeleteProduct}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={updateConfirm}
          onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          fullWidth
        >
          <DialogTitle align="center">Confirm to Sync</DialogTitle>
          <DialogContent>
            This product is synced with some Shopify Products.
            <br />
            Do you also want to update those synced products?
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setUpdateConfirm(false);
                handleUpdateProduct(updatedProduct, false);
              }}
            >
              No
            </Button>
            <Button
              variant="contained"
              size="small"
              type="submit"
              onClick={() => {
                setUpdateConfirm(false);
                handleUpdateProduct(updatedProduct, true);
              }}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <Dialog
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth
        open={openImageDialog}
      >
        <DialogTitle>Image Data</DialogTitle>
        <DialogContent>
          <Grid item xs={12}>
            <TextField
              id="title"
              name="title"
              label="Title"
              fullWidth
              value={imageMeta.title}
              onChange={(e) => {
                setImageMeta({ ...imageMeta, title: e.target.value });
              }}
              variant="standard"
            />
          </Grid>
          <Grid mt={1} item xs={12}>
            <TextField
              id="description"
              name="description"
              label="Description"
              fullWidth
              variant="standard"
              value={imageMeta.description}
              onChange={(e) => {
                setImageMeta({ ...imageMeta, description: e.target.value });
              }}
            />
          </Grid>
          <Box mt={3} display={"flex"} justifyContent={"flex-end"} gap={2}>
            <Button variant="outlined" size="small" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleSaveImageMeta}
            >
              Save
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={deleteConfirmImage}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle>Confirm to Delete Image</DialogTitle>
        <DialogContent>
          Are you sure to delete this Image? This action will perform
          immediately.
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setDeleteConfirmImage(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              if (imageToDeleteId) handleDeleteImage();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {isLightBoxOpen && (
        <Lightbox mainSrc={lightBoxURL} onCloseRequest={handleClose} />
      )}
    </>
  );
};
